module.exports = __webpack_public_path__ + "img/OmniBTC.0dfb07f3.png";